// 9fbef606107a605d69c0edbcd8029e5d
import ADD_PICKUP_CONSTANTS from './AddPickUpPersonForm.constants';

export const addPickUpPerson = (payload = {}) => {
  return {
    type: ADD_PICKUP_CONSTANTS.ADD_PICKUP_PERSON,
    payload,
  };
};

export const setAddPickupErrorMesssage = (payload = {}) => {
  return {
    type: ADD_PICKUP_CONSTANTS.SET_PICKUP_PERSON_ERROR_MSG,
    payload,
  };
};

export const resetOrderPagination = (payload) => {
  return {
    type: ADD_PICKUP_CONSTANTS.RESET_ORDER_PAGINATION,
    payload,
  };
};

export const showSuccessMessage = (payload) => {
  return {
    type: ADD_PICKUP_CONSTANTS.SHOW_SUCCESS_MSG,
    payload,
  };
};

export const setModalData = (payload) => {
  return {
    type: ADD_PICKUP_CONSTANTS.SET_MODAL_DATA,
    payload,
  };
};

export const showErrorMessage = (payload) => {
  return {
    type: ADD_PICKUP_CONSTANTS.SHOW_ERROR_MSG,
    payload,
  };
};

export const showLoader = () => {
  return {
    type: ADD_PICKUP_CONSTANTS.SHOW_LOADER,
  };
};

export const hideLoader = () => {
  return {
    type: ADD_PICKUP_CONSTANTS.HIDE_LOADER,
  };
};

export const resetState = () => {
  return {
    type: ADD_PICKUP_CONSTANTS.RESET_STATE,
  };
};

export const openForm = (payload) => {
  return {
    type: ADD_PICKUP_CONSTANTS.OPEN_FORM,
    payload,
  };
};
